import React, { PureComponent } from 'react';
import LoginFormContainer from './LoginFormContainer';
import LoginPageParent from '../../components/login/LoginPageParent';
import { connect } from 'react-redux';
import RoutingContainer from '../shared/RoutingContainer';
import cookie from 'utilities/cookie';
import svc from 'svc';
import {actions} from 'config/reduxIndex';



class Login extends PureComponent {

	componentDidMount() {
		const session = cookie.get('session');
		const {setLogin} = this.props;
		console.log('SESSION', session)

		if (session) {
			console.log(session);
			setLogin({pending: true, requiresLogin: true});

			svc.sessionSet(session['session'], session['token']).then((res) => {
				cookie.set('requiresRelog', false, {path: '/'});
				cookie.set('empID', session.empID, {path: '/'});
				cookie.set('userID', session.userID, {path: '/'});
				console.log(res);
				setLogin({pending: false, requiresLogin: false});
			}).catch((err) => {
				console.log(err);
				cookie.set('requiresRelog', true, {path: '/'});
				cookie.remove('session', {path: '/'});
				svc.close();
				setLogin({pending: false, requiresLogin: true});
			});
		} else {
			cookie.set('requiresRelog', true, {path: '/'});
			setLogin({pending: false, requiresLogin: true});
		}
	}

	render() {
		return <LoginPageParent>
			<LoginFormContainer 
				defaultRoutePostLogin = { true }
			/>
			<RoutingContainer />
		</LoginPageParent>
	}
}


const mapDispatchToProps = dispatch => ({
	setLogin: (data) => (dispatch(actions.login.setState(data))),
});


export default connect(null, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/containers/login/Login.js